<form class="flex flex-column" (validate)="save()" novalidate validation-es>

  <div class="col-12 inline-flex align-items-center">
    <div class="col">
      <p-autoComplete name="specialties" [(ngModel)]="specialtyHelp" class="no-margin" [suggestions]="specialtiesShowed"
        [dropdown]="true" [forceSelection]="true" field="label" dataKey="value" inputStyleClass="uppercase"
        (completeMethod)="showSuggestions($event)" (onSelect)="add()" appendTo="body" validation>
      </p-autoComplete>
    </div>
    <div class="col-fixed" [style.width.px]="50">
      <button pButton icon="fas fa-plus" class="p-button-success" [pTooltip]="screen.actions.addSpecialty"
        [disabled]="specialtyHelp == null" (click)="add()">
      </button>
    </div>
  </div>

  <div class="col-12 inline-flex" *ngFor="let specialty of specialtiesToSave">
    <span class="col inline-flex align-items-center">
      {{specialty.name}}
    </span>
    <span class="col-fixed" [style.width.px]="50">
      <button pButton icon="far fa-trash-alt" class="p-button-danger" (click)="remove(specialty.id)">
      </button>
    </span>
  </div>

  <hr>

  <div class="align-self-end">
      <button pButton [type]="loading ? 'button' : 'submit'" [label]="screen.actions.save"
      [icon]="loading ? loadingIcon : 'far fa-save'" iconPos="left" class="p-button-success p-button-outlined"></button>
  </div>
</form>